<template>
    <b-modal
        ref="productModal"
        footer-class="p-0"
        v-model="showModal"
    	:title="data_item ? data_item.title : ''" 
        hide-header
		scrollable> 
        
        <header id="item-header" class="modal-header">       
            <p class="h5">{{data_item ? data_item.title : ''}} 
                <button id="tooltip-target-1" 
                        class="btn btn-link"
                        v-show="data_item.info"
                        @click="item_info(data_item)"
                        type="button">
                            <i v-if="data_item" 
                            class="fas fa-info-circle" ></i>
                </button>                 
            </p>

            <b-tooltip target="tooltip-target-1" triggers="hover">
                {{data_item.info}}
            </b-tooltip>              
            
            <button
                type="button"
                class="close"
                @click="modal_closed">x</button>        
        </header>
        <div v-if="data_item">
            <div v-if="data_item.description">{{data_item.description}}</div>
            <div class="product-image mt-3" v-if="data_item.media">
                <b-img-lazy v-if="data_item.media.rectangleUrl" :src="data_item.media.rectangleUrl" :alt="data_item.title" />
                <b-img-lazy v-else-if="data_item.media.thumbNail" :src="data_item.media.thumbNail" :alt="data_item.title" />                
            </div>
            <div class="product-image mt-3" v-else-if="data_item.image">
                <b-img-lazy :src="data_item.image" :alt="data_item.title"/>
            </div>

            <!-- product modifier -->
            <div class="product-modifier mt-3" 
                v-for="(optiongroup,index) in data_item.optionGroups" 
                :key="'option-group-' + index"
                :id="'item_'+index">   
                <div class="product-modifier-header"
                    :class="{
                        'is-required': optiongroup.choiceMin > 0, 
                        'is-checked': check_passed(optiongroup, index)
                    }">

                    <div class="pr-4">
                        <div class="weight-700">{{optiongroup.title}}</div>
                        <div>{{optiongroup.subTitle}}</div>
                    </div>
                    <div  class="modifier-required">
                        <b-badge variant="warning" class="badge-normal" 
                            :class="{'badge-flashing' : index === highLightIndex}">Required</b-badge>
                    </div>
                    <div class="modifier-checked">
                        <i class="far fa-check-circle"></i>
                    </div>
                </div>                                    
                <div class="product-modifier-body">
                    <div class="d-flex" 
                        v-for="(option, option_index) in optiongroup.options" 
                        :key="'option-index-' + option_index">

                        <counter 
                                v-if="optiongroup.choiceMax < 2 ? false : optiongroup.duplicates"                                                         
                                :disableMax="disable_max_option(index, option_index)"
                                :ref='"counter_" + index + "_" + option_index'                                 
                                :count="getCount(index, option_index)"
                                @on-count="onCount($event, index, option_index)" />

                        <div v-else-if="optiongroup.choiceMax < 2">
                            <p-radio class="p-default pretty pretty-block" 
                                color="primary"
                                :class="{
                                    'p-round': optiongroup.choiceMax < 2
                                }" 
                                :name="'option-index-' + index"
                                :checked="choice_is_selected(index, option_index)"
                                @change="select_option(index, option_index)">
                                <span>&nbsp;</span>                                
                            </p-radio>
                        </div>

                        <div  v-else-if="optiongroup.choiceMax > 1">
                            <p-check class="p-default pretty pretty-block" color="primary"
                                :class="{
                                    'p-round': optiongroup.choiceMax < 2
                                }" 
                                :checked="choice_is_selected(index, option_index)"
                                :disabled="disable_option(index, option_index)"
                                @change="select_option(index, option_index)">
                                <span>&nbsp;</span>
                            </p-check>                            
                        </div>
                        <span class="flex-grow-1 can_click" v-if="optiongroup.choiceMax < 2 ? false : optiongroup.duplicates">{{option.title}}</span>                                                                                    
                        <span class="flex-grow-1 can_click" v-else-if="optiongroup.choiceMax < 2" @click="select_option(index, option_index)">{{option.title}}</span>                                                                                    
                        <b-button variant="link" class="flex-grow-1 can_click p-0 text-left text-dark" v-else-if="optiongroup.choiceMax > 1" @click="select_option(index, option_index)" :disabled="disable_option(index, option_index)">{{option.title}}</b-button>

                        <span class="pretty-label-right" v-if="option.price">{{(option.price/100) | currency}}</span>
                    </div>
                </div>
            </div>
            <!-- product modifier -->
            <!-- special notes -->
            <div class="product-modifier mt-3">
                <div class="product-modifier-header is-required is-checked">
                    <div class="pr-4">
                        <div class="weight-700">Special instructions</div>
                    </div>
                </div>
                <div class="product-modifier-body">
                    <b-form-textarea
                        id="textarea-rows"
                        rows="4"
                        maxlength="200"
                        v-model="special_note"
                        @keyup="change_on_choice" />
                </div>
            </div>
            <!-- quantity -->
            <div class="product-modifier mt-3">
                <div class="product-quantity d-flex justify-content align-items-center">
                    <div class="weight-700">Quantity</div>
                    <div class="quantity-input">
                        <span class="decrease" @click="change_quantity('decrease')"><i class="fas fa-minus"></i></span>
                        <span class="counter"> {{this.quantity}} </span>
                        <span class="increase" @click="change_quantity('increase')"><i class="fas fa-plus"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="full-width">
            <button 
                class="btn btn-primary btn-block" 
                @click="add_to_cart">
                <div class="d-flex justify-content-between align-items-center">
                    <div><i class="fas fa-shopping-cart"></i> Add to Cart({{quantity}})</div>
                    <div>{{total_price/100 | currency}}</div>
                </div>
            </button>
        </div>
    </b-modal>
</template>

<script>
import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import Counter from '@/components/menu/Counter'
var $ = require('jquery')
// import PrettyInput from 'pretty-checkbox-vue/input';

import Swal from 'sweetalert2'
var swal = null
var isCloseByBack
export default {
    components: {
        'p-check': PrettyCheck,
        'p-radio': PrettyRadio,
        Counter
        // 'p-input': PrettyInput,
    },
    props: {
        data_item: { type: Object },
        'cart-item-index': {type: Number}
    },
    data()
    {
        return {
            highLightIndex : -1,
            selected_options: [],
            total_price: 0,
            quantity: 1,
            is_valid: false,
            special_note: '',
            showModal: true
        };
    },
    watch: {
        data_item: {
            deep: true,
            handler() {
                this.fetchData
            }
        }
    },
    created() {   
        this.fetchData()
        window.addEventListener('hashchange', this.hash_change)
    },
    destroyed: function () {
        window.removeEventListener('hashchange', this.hash_change)
    },
    mounted() 
    {
        // modal window close event
        this.$root.$on('bv::modal::hide', () => this.modal_closed());
        history.pushState(null, null, '#/ProductModal');
    },
    methods: {
        hash_change(hash){
//            console.log("ProductModal", hash)
            let oldURL = new URL(hash.oldURL)
            if(swal!=null && oldURL.hash === "#/ProductModal-ItemInfoModal"){
                isCloseByBack = true
                swal.close()
            }
        },
        /**
         * 
         * 
         */
        modal_closed() {
            this.$emit('close')
        },
        choice_is_selected(index, option_index)
        {
            var selected = false;        

            if(this.selected_options)
            {
                var option_group = this.selected_options.find(item => item.option_group == index);
                selected = option_group.options && option_group.options.indexOf(option_index) > -1 ? true : false;
            }

            return selected;
        },
        getCount(index, option_index){ 
            if(!this.selected_options) {
                 return 1;
            }
            
            var option_group = this.selected_options.find(item => item.option_group == index);
            if(!(option_group.size && option_index in option_group.size)){
                alert("Please contact to me with this state.")// Useless condition. this will remove after successfully test
                var  selected = option_group.options && option_group.options.includes(option_index)
                return selected ? 1 : 0
            }                      
            return option_group.size[option_index]
        },
        /**
         * user interacts with item and makes changes 
         * 
         */
        change_on_choice()
        {
            // calculate total price
            this.calculate_total_price();
            // validate
            this.validate_item();

            // emit event
            this.$emit('change', this.is_valid, this.data_item._id, this.selected_options, this.quantity,  
                this.special_note, this.total_price, this.cartItemIndex);
        },

        onCount(size, option_group, option){             
            // index of this.selected_options
            var indx = false;
            this.selected_options.forEach( (item,index) => {
                if(item.option_group == option_group) indx = index;
            });
            if((this.choice_is_selected(option_group, option) && size === 0) || (!this.choice_is_selected(option_group, option) && size > 0)){
                this.select_option(option_group, option)
            }
            this.selected_options[indx].size[option] = size;       
            this.change_on_choice()           
        },
        /**
         * 
         * 
         */
        select_option(option_group, option)
        {
            var is_multi_option = this.data_item.optionGroups[option_group].choiceMax > 1 ? true : false;
            // index of this.selected_options
            var indx = false;
            this.selected_options.forEach( (item,index) => {
                if(item.option_group == option_group) indx = index;
            });
            
            //let counter = this.$refs["counter_" + option_group + "_" + option];            
            //if(counter !== undefined){
            //    size = counter[0].myCount
            //}            
            
            if(is_multi_option)
            {
                // index of option in this.selected_options group index
                var index_of_option_of_group = this.selected_options[indx].options.indexOf(option);

                if(index_of_option_of_group < 0)
                {
                    this.selected_options[indx].options.push(option);                   
                }
                else
                {
                    this.selected_options[indx].options.splice(index_of_option_of_group, 1);
                }
                this.selected_options[indx].size[option] = 1;
            }
            else
            {
                this.selected_options[indx].size = {}
                this.selected_options[indx].size[option] = 1
                this.$set(this.selected_options[indx], 'options', [option]);
            }
            // check cart
            this.change_on_choice();
        },

        /**
         * Check modifier passes required choose count
         * 
         */
        check_passed(option_group, index)
        {
            var passed = false;

            if(option_group.choiceMin > 0)
            {                   
                var selectedOptions = this.selected_options[index];
                var optionSize = 0;
                selectedOptions.options.forEach(option=>{
                    optionSize += selectedOptions.size[option];
                }) 

                if(optionSize <= option_group.choiceMax 
                    && optionSize >= option_group.choiceMin){
                    passed = true;
                }
            }
            else
            {
                passed = true;
            }

            return passed;
        },

        /**
         * disable option
         * 
         */
        disable_option(option_group_index, option_index)
        {
            var disable = false;

            var choice_max = this.data_item.optionGroups[option_group_index].choiceMax;

            if( this.selected_options[option_group_index].options.indexOf(option_index) < 0 
                && choice_max == this.selected_options[option_group_index].options.length)
            {
                disable = true;
            }

            return disable;
        },
        disable_max_option(index)
        {   
            var disable = false;

            var choice_max = this.data_item.optionGroups[index].choiceMax;

            var selectedOptions = this.selected_options[index];

            var optionSize = 0;
            selectedOptions.options.forEach(option=>{
                optionSize += selectedOptions.size[option];
            })
            if(optionSize >= choice_max){
                disable = true;
            }

            return disable;
        },
        /**
         * Count cart total price
         * 
         */
        calculate_total_price()
        {
            if(this.data_item)
            {
                var price = this.data_item.price;

                if(this.data_item.optionGroups){
                    this.data_item.optionGroups.forEach( (item, index) => {
                        item.options.forEach( (option, option_index) => {
                            if(this.selected_options[index].options.indexOf(option_index) > -1 
                                && Number.isInteger(option.price))
                            {
                                price += option.price * (this.selected_options[index].size[option_index]);
                            }
                        });
                    });
                }

                this.total_price = price * this.quantity;
            }
        },

        /**
         * 
         * 
         */
        change_quantity(type)
        {
            if( type == 'decrease' && this.quantity > 1)
            {
                this.quantity -= 1;
            }
            else if( type == 'increase' )
            {
                this.quantity += 1;
            }

            
            this.change_on_choice()
        },

        /**
         * Product ready for adding to cart
         * 
         */
        validate_item()
        {
            var choice_passed = true;
            if (this.data_item.optionGroups.length > 0) {
                this.data_item.optionGroups.forEach((option_group, index) => {
                    if(option_group.choiceMin > 0)
                    {                                       
                        var selectedOptions = this.selected_options[index];

                        var optionSize = 0;
                        selectedOptions.options.forEach(option=>{
                            optionSize += selectedOptions.size[option];
                        })
                                                
                        if(option_group.choiceMax < optionSize || option_group.choiceMin > optionSize)
                        {
                            choice_passed = false;
                        }
                    }
                });
            }

            // is valid or not
            this.is_valid = this.quantity >= 1 && choice_passed && this.special_note.length <=200
                ? true : false;
        },


        add_to_cart(){
            if (this.is_valid)
            {
                this.cart_item_obj = {
					item_id: this.data_item._id,
					quantity: this.quantity,
					special_note: this.special_note,
					total_price: this.total_price,
					selected_options: this.selected_options
                }
                
                if(this.cartItemIndex != null ) // when update
                {
                    this.$store.dispatch('updateCart', {
                        cart_index: this.cartItemIndex,
                        data: this.cart_item_obj
                    });
                }
                else
                {
                    this.$store.dispatch('customerLog', "Item, " +  `"${this.data_item.title}"` + " Added");
                    this.$store.dispatch('addItemToCart', this.cart_item_obj);
                }

                this.item_added_to_cart();
            }
            else
            {   
                this.highLightIndex = -1
                for(let i = 0; i <this.data_item.optionGroups.length; i++) {
                    let isRequired = this.data_item.optionGroups[i].choiceMin > 0;         
                    let isCheckPassed = this.check_passed(this.data_item.optionGroups[i], i);                       
                     if(isRequired && !isCheckPassed) {
                        let {top} = $(`#item_${i}`).offset();
                        $('.modal-content > .modal-body').scrollTop(top);
                        this.highLightIndex = i;
                        break;                        
                     }
                }            
            }
        },
        item_added_to_cart(){
            var toast_title = this.quantity == 1 ? this.quantity + ' item added' : this.quantity + ' items added';

            // show success warning alert
            this.show_toast_alert(toast_title, 'success');

            // close modal
            this.$emit('close')
            
        },
        show_toast_alert(title, status){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: status,
                title: title
            })
        },
        fetchData() {
            if(this.data_item) {
                this.total_price = this.data_item.price;

                if(this.data_item.optionGroups){
                    this.data_item.optionGroups.forEach((item, index) => {
                        let option = {
                            option_group: index,
                            options: [],
                            size:{}
                        }
                        if(item.options !== undefined){
                            item.options.forEach((_option, index)=>{
                              option.size[index] = 0
                            })
                        }
                        this.selected_options.push(option);
                    });
                }
            }
            
            var cart_item = this.$store.getters.cartItems.find( (item, index) => index == this.cartItemIndex );

            if(cart_item) {
                this.total_price = cart_item.total_price;
                this.is_valid = true;
                this.quantity = cart_item.quantity;
                this.special_note = cart_item.special_note;

                cart_item.selected_options.forEach(c_s_o => {
                    var s_o = this.selected_options.find(item => item.option_group == c_s_o.option_group);
                    s_o.size = c_s_o.size
                    // console.log(c_s_o);
                    c_s_o.options.forEach(c_option => s_o.options.push(c_option));
                });
            } else {
                this.data_item.optionGroups.forEach((optionGroup, index) => {
                    optionGroup.options.forEach((option, sub_index) => {
                        if (option.preselect) {
                            this.select_option(index, sub_index)
                        }
                    })
                })
                if (this.data_item.optionGroups.length === 0) {
                    this.is_valid = true
                } else {
                    this.is_valid = this.data_item.optionGroups.every(({ choiceMin }) => choiceMin === 0)
                }
            }
        },
        item_info(item) { 
        isCloseByBack = false 
        swal =  Swal.fire({
                title: item.title,
                html: '<span style="white-space: pre-line;">'+item.info+'</span>',
                showCancelButton: false,
                onClose: this.onCloseItemInfo,
                onOpen: this.onOpenItemInfo 
            });            
            //this.$parent.item_info_show(item);     // call parent but use event 
        },
        onOpenItemInfo(){
            history.replaceState(null, null, '#/ProductModal-ItemInfoModal');                      
        },
        onCloseItemInfo(){
            if(!isCloseByBack){
               history.replaceState(null, null, '#/ProductModal'); 
            }else{
               history.pushState(null, null, '#/ProductModal');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .product-image{
        overflow: hidden;
        position: relative;
        width: 100%;
        height: 250px;
        border-radius: 5px;

        img{
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .product-modifier-header{
        background-color: #ededed;
        padding: 10px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.is-required .modifier-required{
            display: block;
        }

        &.is-required.is-checked .modifier-required{
            display: none;
        }

        &.is-checked .modifier-checked{
            display: block;
        }

        .modifier-checked{
            font-size: 30px;
            color: rgba(0,0,0, .5);
            display: none;
        }

        .modifier-required{
            color: rgba(0,0,0, .5);
            display: none;
        }
    }
    
    .form-group-n{
        position: relative;
        width: 100%;

        .price{
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    .product-modifier-body{
        padding: 0px 0px;
    }

    .custom-control-label{
        display: block !important;
    }

    .product-quantity{
        padding: 10px 15px;
        background-color: #ededed;
    }

    .quantity-input{
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;

        .increase, .decrease{
            display: block;
            width: 30px;
            height: 30px;
            /* border: 1px solid; */
            border-radius: 50%;
            text-align: center;
            font-size: 19px;
            background-color: var(--primary);
            color: #fff;
            margin: 0 15px;
            cursor: pointer;
        }
    }

    .pretty.pretty-block{
        display: block;
        margin-right: 0;

        .pretty-label-right{
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    .tooltip {
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        opacity: 100;
        left:100px;
    }

    .modal-header{
        padding: 0 0;
    }
    .p-default{
        margin-top: 5px;
    }
    .can_click:hover {
        cursor: pointer;
    }

    .badge-normal {
        background-color: yellow;
    }

    @keyframes breathing-color--light {
            from
            {
                background-color: yellow;
            }
            to
            {
                background-color: red;
            }
        }
    .badge-flashing {
        animation: 1s infinite alternate ease-out breathing-color--light;
    }
        
</style>